var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ViewUiCalloutIcon',{staticClass:"view-ui-state-comingsoon",attrs:{"iconFilename":"chalkysticks.svg","message":'<strong>Stay tuned</strong><br />' + _vm.featureName + ' is coming soon'}})
}
var staticRenderFns = []

export { render, staticRenderFns }